(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kraven-product-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__kravenFitmentJumpBound) return
    window.__kravenFitmentJumpBound = true

    const findTarget = (trigger) => {
      const requestedTarget = trigger?.getAttribute('href')
      if (requestedTarget?.startsWith('#')) {
        const exactTarget = document.querySelector(requestedTarget)
        if (exactTarget) return exactTarget
      }

      return document.querySelector(
        '#kraven-fitment-details, #kraven-exact-fitment, #dossier-fitment, #kraven-fitment, #fitment'
      )
    }

    const revealFitment = (target) => {
      if (!target) return

      if (target.matches('details')) target.open = true
      const nestedDetails = target.querySelector?.('details')
      if (nestedDetails) nestedDetails.open = true

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
          target.classList.add('is-fitment-target')

          const focusTarget = target.matches('details') ? target.querySelector('summary') : target
          focusTarget?.focus?.({ preventScroll: true })

          window.setTimeout(() => target.classList.remove('is-fitment-target'), 1500)
        })
      })
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-kraven-fitment-link]')
      if (!trigger) return

      const target = findTarget(trigger)
      if (!target) return

      event.preventDefault()
      revealFitment(target)

      if (target.id && window.history?.replaceState) {
        window.history.replaceState(null, '', `#${target.id}`)
      }
    })

    const revealFromHash = () => {
      if (window.location.hash !== '#kraven-fitment-details') return
      const target = document.querySelector(window.location.hash)
      if (target?.matches('details')) target.open = true
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealFromHash, { once: true })
    } else {
      revealFromHash()
    }
  })()
  } catch(e) { console.error(e); }
})();

})();
